var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit-promotion"},[_c('promotion-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }